module.exports = __webpack_public_path__ + "static/media/Brands_21.42302f17.png";